import React, { useEffect } from "react";
import { useState } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import {
  fetchDeveloperToolsScriptsExecutePost,
  fetchDeveloperToolsScriptsGet,
} from "../../../services/api-raindrop.js";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import Spacer from "../../../ui-components/spacer/spacer";

const ScriptComponent = ({ name, description, slug, setResponse }) => {
  const onSubmit = () => {
    fetchDeveloperToolsScriptsExecutePost({
      scriptSlug: slug,
      isDryRun: false,
    }).then((res) => {
      setResponse(JSON.stringify(res, null, 2));
    });
  };

  const onSubmitDryRun = () => {
    fetchDeveloperToolsScriptsExecutePost({
      scriptSlug: slug,
      isDryRun: true,
    }).then((res) => {
      setResponse(JSON.stringify(res, null, 2));
    });
  };

  return (
    <RaindropCard additionalClasses="w-full gap-4">
      <div className="flex flex-col gap-2 w-full">
        <h1 className="text-left text-normal font-bold w-full">{name}</h1>
        <p className="text-color-dark-text-secondary">{description}</p>
      </div>

      <div className="flex flex-row gap-2 w-full">
        <Spacer />
        <RaindropButton title={"Dry Run"} onClick={onSubmitDryRun} />
        <RaindropButton title={"Execute"} onClick={onSubmit} />
      </div>
    </RaindropCard>
  );
};

const NimbusDeveloperToolsOneOffScripts = () => {
  const [response, setResponse] = useState(null);

  const [scripts, setScripts] = useState<any>(null);

  useEffect(() => {
    fetchDeveloperToolsScriptsGet().then((res) => {
      setScripts(res.scripts);
    });
  }, []);

  if (!scripts) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-row gap-4 justify-around w-full h-full overflow-scroll items-center p-6">
      <div className="flex flex-col max-w-lg w-full h-full">
        <RaindropScrollContainer>
          {scripts &&
            scripts.map((script) => (
              <ScriptComponent
                key={script.slug}
                name={script.name}
                slug={script.slug}
                description={script.description}
                setResponse={setResponse}
              />
            ))}
        </RaindropScrollContainer>
      </div>

      <div className="flex flex-col w-full max-w-lg h-96 overflow-scroll items-center justify-center">
        <pre
          className="h-full  rounded-lg flex flex-col items-start p-4 w-full overflow-scroll text-xs
        bg-color-raindrop-disabled dark:bg-color-raindrop-disabled
        text-color-dark-text-primary
        "
        >
          {response}
        </pre>
      </div>
    </div>
  );
};

export default NimbusDeveloperToolsOneOffScripts;
